import { QueryClientProvider } from "@tanstack/react-query"
import { Toaster } from "sonner"
import { queryClient } from "@/lib/query-client"
import { TooltipProvider } from "@/components/ui/tooltip"
import { ThemeApplier } from "@/components/ThemeApplier"
import { useUIStore } from "@/store/ui.store"

function ToasterWithTheme() {
  const theme = useUIStore((s) => s.theme)
  return (
    <Toaster
      theme={theme}
      position="top-right"
      richColors
      closeButton
      duration={4000}
    />
  )
}

interface ProvidersProps {
  children: React.ReactNode
}

export function Providers({ children }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <ThemeApplier />
        {children}
        <ToasterWithTheme />
      </TooltipProvider>
    </QueryClientProvider>
  )
}
